import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter
} from "react-router-dom";
import { LandingPage } from "../pages/LandingPage";
import { PlanPage } from "../pages/PlanPage";

const AppRoutes = props => {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/como-usar-tu-plan" component={LandingPage} />
          <Route
            exact
            path="/como-usar-tu-plan/planes/:planId"
            component={PlanPage}
          />
        </Switch>
      </div>
    </Router>
  );
};

export default AppRoutes;
